"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Tabs_1 = __importDefault(require("@mui/material/Tabs"));
var SwatchButton = __importStar(require("./swatchButton"));
var material_1 = require("@mui/material");
var themes_1 = require("./themes");
var Component = function (p) {
    var classes = (0, themes_1.useTabStyles)();
    return (Preact.h(Tabs_1.default, { value: p.activeSwatchIndex, "aria-label": "swatch selection", variant: "scrollable", classes: {
            root: classes.root,
            scroller: classes.scroller,
            indicator: classes.hideIndicator,
        } }, p.tabContents.map(function (swatch, i) { return (Preact.h(material_1.Box, { paddingLeft: i === 0 ? 0 : '30px' },
        Preact.h(SwatchButton.Component, { active: swatch.active, warning: swatch.warning, image: swatch.image, colour: swatch.colour, onClick: function () { return !swatch.active && p.onSelectSwatch(swatch.label); }, label: swatch.label }))); })));
};
exports.Component = Component;
